<template>
  <div class="iconic-field-wrapper">
    <label :for="id" class="sr-only">{{label}}</label>
    <input :id="id" :type="type || 'text'" :value="modelValue" :required="required" :autofocus="autofocus"
           :placeholder="label"
           :min="min"
           :max="max"
           :class="{'error': hasError}"
           @blur="validate"
           @focus="clearValidation"
           @input="$emit('update:modelValue', $event.target.value)"
    >
  </div>
</template>

<script>


export default {
  props: {
    id: { type: String, default: ""},
    type: { type: String, default: ""},
    label: { type: String, default: ""},
    min: { type: String, min: ""},
    max: { type: String, max: ""},
    required: {
      type: Boolean,
      default: true
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    modelValue: { type: String, default: ""}
  },
  emits: ['update:modelValue'],
  data: () => ({
    hasError: false
  }),
  methods: {
    clearValidation() {
      this.hasError = false
    },
    validate() {
      if(this.required && !this.modelValue) {
        this.hasError = true
        return
      }
      this.hasError = false
    }
  }
}
</script>

<style scoped lang="scss">
.iconic-field-wrapper {
  padding: .25em 0;
  input {
    font-family: $font-family-primary;
    font-size: .8rem;
    padding: .75em;
    margin-bottom: .25;
    width: calc(100% - 1.5em);
    border:none;
    background-image: none;
    background-color: #f1f1f1;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }
}
.error {
  border:1px solid red;
}
</style>
